var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"padding":"10px 5px","background-color":"#ffffff"}},[_c('el-col',{staticStyle:{"border-radius":"20px","overflow":"hidden"},attrs:{"span":24}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('GmapMap',{staticClass:"img-13",staticStyle:{"width":"100%","height":"250px"},attrs:{"center":{
            lat: _vm.listingDetails.latitude,
            lng: _vm.listingDetails.longitude
          },"options":{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false
          },"zoom":15}},[_c('GmapMarker',{attrs:{"icon":require('../../assets/location.png'),"position":{
              lat: _vm.listingDetails.latitude,
              lng: _vm.listingDetails.longitude
            }}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticStyle:{"background-color":"#003333","color":"#ffffff","padding":"2% 2% 0.5% 2%"},attrs:{"span":24}},[_c('span',{staticClass:"text-dino",staticStyle:{"font-weight":"500","font-size":"18px"}},[_vm._v(_vm._s(_vm.listingDetails.propertyLocationTitle
              ? _vm.listingDetails.propertyLocationTitle
              : "Location,location!"))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticStyle:{"background-color":"#003333","color":"#ffffff","padding":"1% 2% 3% 2%"}},[_c('span',{staticClass:"text-dino",staticStyle:{"font-weight":"300","font-size":"16px"}},[_vm._v(_vm._s(_vm.listingDetails.propertyLocationDescription))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc6cf458","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/listingLocation.vue
// module id = null
// module chunks = 